import * as React from 'react';
import { Text } from '@qga/roo-ui/components';

const SubHeading = ({ children }: React.PropsWithChildren<any>) => (
  <Text color="greys.steel" fontWeight="normal" fontSize={14} mt={1} mb={0}>
    {children}
  </Text>
);

SubHeading.displayName = 'SubHeading';

export { SubHeading };
